// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  ServiceType,
} from "./types";


export default __t.row({
  id: __t.u32().primaryKey(),
  name: __t.string(),
  imageUrl: __t.string().name("image_url"),
  get serviceType() {
    return ServiceType.name("service_type");
  },
  description: __t.string(),
  healthPort: __t.u16().name("health_port"),
  createdBy: __t.identity().name("created_by"),
  createdAt: __t.timestamp().name("created_at"),
  updatedAt: __t.timestamp().name("updated_at"),
  latestDigest: __t.option(__t.string()).name("latest_digest"),
});
